import { Button } from '@quickmd-llc/design-system'

type Props = {
  isLoading: boolean
  onCancel: () => void
  onSendInvite: () => void
}

/**
 * Fixed bottom action bar for the new-member create page: Cancel + Send invite.
 *
 * SCSS → Tailwind mapping ($border-color = var(--border-card) = shade[10]):
 *   .nm-action-bar -> fixed bottom-0 left-[var(--nav-width)] right-0 flex items-center
 *                     justify-end gap-sp-1.5 py-sp-2 px-sp-6 bg-white border-t border-shade-10
 *                     z-[100]
 *     (padding was `16px 48px` → py-sp-2 px-sp-6; left:var(--nav-width) is a layout var, not a
 *      DS token → arbitrary left-[var(--nav-width)]; z-index 100 → arbitrary z-[100],
 *      matching the cluster-1 ViewServiceFooter action bar)
 */
export const NewMemberFooter = ({ isLoading, onCancel, onSendInvite }: Props) => (
  <div
    className='fixed bottom-0 left-[var(--nav-width)] right-0 z-[100] flex items-center justify-end gap-sp-1.5 border-t border-shade-10 bg-white px-sp-6 py-sp-2'
    data-testid='pw_nm-action-bar'>
    <Button priority='secondary' type='button' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      priority='primary'
      type='button'
      id='sendInviteToNewMemberBtn'
      onClick={onSendInvite}
      loading={isLoading}
      data-testid='pw_nm-send-invite'>
      Send invite
    </Button>
  </div>
)
